export const EMPTY_STRING = '';



// WEBPACK FOOTER //
// ./src/const/string.js